module.exports = __webpack_public_path__ + "static/img/youhuijuan.49fd052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/youhuijuan.png
// module id = 4DMm
// module chunks = 1